import { Button } from '@/components/ui/button';

type TeleopCameraControlsProps = {
  activeCamera: string;
  canSwitchCamera: boolean;
  positionClassName: string;
  onSwitchPrevious: () => void;
  onSwitchNext: () => void;
};

const formatCameraLabel = (name: string) => {
  if (!name) {
    return 'Camera';
  }

  const label = name
    .replace(/^cam_/, '')
    .replace(/_/g, ' ');

  return label.toUpperCase();
};

const TeleopCameraControls: React.FC<TeleopCameraControlsProps> = ({
  activeCamera,
  canSwitchCamera,
  positionClassName,
  onSwitchPrevious,
  onSwitchNext,
}) => {
  const activeCameraLabel = formatCameraLabel(activeCamera);

  return (
    <div
      className={`absolute left-1/2 z-10 flex -translate-x-1/2 items-center gap-3 ${positionClassName}`}
    >
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className="h-9 w-9 rounded-full border border-white/15 bg-white/10 text-white/70 hover:bg-white/20"
        onClick={onSwitchPrevious}
        disabled={!canSwitchCamera}
        aria-label="Previous camera"
      >
        ◀
      </Button>
      <div className="rounded-full border border-white/10 bg-white/10 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-white/80">
        {activeCameraLabel}
      </div>
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className="h-9 w-9 rounded-full border border-white/15 bg-white/10 text-white/70 hover:bg-white/20"
        onClick={onSwitchNext}
        disabled={!canSwitchCamera}
        aria-label="Next camera"
      >
        ▶
      </Button>
    </div>
  );
};

export default TeleopCameraControls;
